import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'value-selector',
  templateUrl: './value-selector.component.html',
  styleUrls: ['./value-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValueSelectorComponent {
  public tempType = InputType.TEMPERATURE;

  @ViewChild(IonInput) input!: IonInput;

  @Input() title: string = '';
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 999;

  @Input() type: InputType = InputType.NUMBER;
  @Input() compact: boolean = false;
  @Input() border: boolean = false;

  @Input() disabled: boolean = false;

  @Output() onValueSelected: EventEmitter<number> = new EventEmitter();

  public get showTempLabel(): boolean {
    return this.type !== InputType.NUMBER;
  }

  public onInput(event: CustomEvent) {
    const filtered = (<string>event.detail.value).replace(/[^0-9]+/g, '');
    this.input.value = +filtered;
  }

  public onChange(event: CustomEvent) {
    let value = +event.detail.value;

    if (value > this.max) {
      this.input.value = this.max;
      value = this.max;
    } else if (value < this.min) {
      this.input.value = this.min;
      value = this.min;
    }

    this.onValueSelected.emit(value);
  }
}

export enum InputType {
  NUMBER = '',
  SECONDS = ' seconds',
  MINUTES = ' minutes',
  TEMPERATURE = '° F'
}